import { gql } from '@apollo/client';

const MUTATION = gql`
  mutation UpdateInstallment($id: Int!, $canceled: Boolean, $scheduledDate: String) {
    updateInstallment(id: $id, input: { scheduled_date: $scheduledDate, canceled: $canceled }) {
      id
    }
  }
`;

export default MUTATION;
